import { Gateway } from 'types/embedded/gateway';

export const getGatewayCurrencyIds = (gateway: Gateway | undefined): string[] => {
  if (!gateway) {
    return [];
  }
  const supported = gateway.supportedCurrencies?.map((c) => c['@id']) ?? [];
  const defaultId = gateway.defaultCurrency?.['@id'];
  return defaultId ? [...supported, defaultId] : supported;
};
